import api from '@/apis/di/budgetProvideAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';
import { ModuleBudgetProvide } from '@/stores/moduleConst';

// Combo grid Mã dự phòng
export const useBudgetProvideComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetProvideComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'budget_provide_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const budgetProvideComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã dự phòng',
        dataField: 'budget_provide_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Diễn giải',
        dataField: 'budget_provide_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'budget_provide_code',
    valueField: 'budget_provide_code',
    queryMode: 'remote',
    quickSearch: 'BudgetProvideQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive,
    },
    dropdownWidth: 600,
    comboboxLoadData: onBudgetProvideComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    budgetProvideComboConfig,
    onBudgetProvideComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
